import { useState, useEffect } from 'react'

import { Navigate, useLocation, useNavigate } from 'react-router-dom'
import { useCustomAxios } from '../../axiosInstance'

import 'react-responsive-carousel/lib/styles/carousel.min.css' // requires a loader

import { useContext } from 'react'
import { ResetPasswordContext } from './index'
import MuiInput from '../../components/MaterialComponent/MuiInput'
import MuiButton from '../../components/MaterialComponent/MuiButton'
import Link from '@mui/material/Link'
import Grid from '@mui/material/Grid'
import { toastError, toastSuccess } from '../../util/toastUtil'
import { RESETPASSWORD_ENDPOINTS } from '../../constants/apiConstants'
import SendIdWithEmailForm from '../../components/ResetIdWithEmailForm/SendIdWithEmailForm'

const Step1 = ({ setCurrentStep, STEP, setLoadingData }) => {
    const axios = useCustomAxios()
    const navigate = useNavigate()
    const [resetEmail, setResetEmail] = useState('')
    const [emailForSendId, setEmailForSendId] = useState('')
    const [emailError, setEmailError] = useState(false)
    const [tmdid, setID] = useState('')
    const [resetEmailError, setResetEmailError] = useState(false)
    const [showSendIdWithEmailForm, setShowSendIdWithEmailForm] =
        useState(false)
    const [contextData, setContextData] = useContext(ResetPasswordContext)

    function ValidateEmail(mail) {
        if (/^[^@]+@[^@]+\.[^@]+$/.test(mail)) {
            return true
        }
        return false
    }

    const handleSubmitResetPassword = async (e) => {
        e.preventDefault()

        if (!ValidateEmail(resetEmail)) {
            setResetEmailError(true)
            return
        } else {
            setResetEmailError(false)
        }

        try {
            // Define the data and options variables if they are not already defined
            setLoadingData(true)
            const data = {
                email: resetEmail,
                roleId: 8,
                userID: tmdid,
            }
            const options = {
                headers: { 'content-type': 'application/json' },
            }

            // Make the Axios GET request
            const { data: responseData } = await axios.post(
                RESETPASSWORD_ENDPOINTS._2FA,
                data,
                options
            )

            // Check if the response exists
            if (responseData) {
                // Update the context data with the new user details
                sessionStorage.setItem(
                    'resetPassToken',
                    responseData.accessToken
                )
                const userDetails = {
                    email: responseData.email,
                    userId: responseData.userId,
                    phoneNumber: responseData.phoneNumber,
                    roleId: 8,
                }
                setContextData((prevContextData) => ({
                    ...prevContextData,
                    userDetails: userDetails,
                }))

                // Move to the next step
                setLoadingData(false)
                setCurrentStep(STEP.step2)
            }
        } catch (error) {
            // Handle the error appropriately
            // console.error('An error occurred while fetching data:', error)
            setLoadingData(false)
            toastError(
                error.response.data && typeof error.response.data === 'string'
                    ? error.response.data
                    : 'Something went wrong, please try again.'
            )
        }
    }

    const onSumbitSendIdWithEmailForm = async (e) => {
        e.preventDefault()
        if (!ValidateEmail(emailForSendId)) {
            setEmailError(true)
            return
        } else {
            setEmailError(false)
        }

        setLoadingData(true)

        await axios
            .post(
                RESETPASSWORD_ENDPOINTS.REQUESTID +
                    `?email=${encodeURIComponent(emailForSendId)}`
            )
            .then((response) => {
                //get token from response
                toastSuccess(
                    response.data && typeof response.data === 'string'
                        ? response.data
                        : 'Email sent successfully'
                )
                setLoadingData(false)
                displaySendIdWithEmailForm(e)
                setEmailForSendId('')
            })
            .catch((err) => {
                setEmailForSendId('')
                toastSuccess(
                    err.response.data && typeof err.response.data === 'string'
                        ? err.response.data
                        : 'Something went wrong, please try again.'
                )
                displaySendIdWithEmailForm(e)
                setLoadingData(false)
                // console.log(err);
            })
    }

    const displaySendIdWithEmailForm = (e) => {
        e.preventDefault()
        setShowSendIdWithEmailForm(!showSendIdWithEmailForm)
    }

    return (
        <>
            {!showSendIdWithEmailForm ? (
                <form className="form" onSubmit={handleSubmitResetPassword}>
                    <h5>Reset Forgotten Password</h5>
                    <p style={{ fontWeight: 'bold', fontSize: 13 }}>
                        Please enter your Email ID and your TMDSAS ID to reset
                        your password
                    </p>
                    <MuiInput
                        required
                        id="email"
                        label="Email Address"
                        name="email"
                        autoComplete="email"
                        onChange={(e) => setResetEmail(e.target.value)}
                        autoFocus
                        error={resetEmailError}
                        value={resetEmail}
                        helperText={resetEmailError && 'Email is not valid'}
                    />
                    <MuiInput
                        type="number"
                        required
                        id="tmdid"
                        label="TMDSAS ID"
                        name="id"
                        onChange={(e) => setID(e.target.value)}
                        value={tmdid}
                    />
                    <MuiButton>Reset Password</MuiButton>
                    <Grid container justifyContent="flex-end">
                        <Link
                            onClick={displaySendIdWithEmailForm}
                            href=""
                            color="#0A5C89"
                            // underline="hover"
                            style={{ fontSize: 17, fontWeight: '500' }}>
                            Forgot ID?
                        </Link>
                    </Grid>
                </form>
            ) : (
                <SendIdWithEmailForm
                    onSubmit={onSumbitSendIdWithEmailForm}
                    onClickCancel={displaySendIdWithEmailForm}
                    error={emailError}
                    value={emailForSendId}
                    helperText={
                        emailError && 'Please enter a valid email address.'
                    }
                    onChange={(e) => setEmailForSendId(e.target.value)}
                />
            )}
        </>
    )
}
export default Step1
